import { useCallback } from 'react';
import { useLogisticaConfiguration } from './LogisticaConfigurationProvider';

// Existing series keys are API transport identities, never editable labels.
export const marketplaceSeriesCodes = Object.freeze({
  amz: 'Amazon', ebay: 'E-bay', prestashop: 'PrestaShop - vs.com',
  storeVS: 'Store - Prato Nevoso', storeJS: 'Store - Torino Jolly',
  cdiscount: 'Cdiscount', eprice: 'ePrice', colizey: 'Colizey',
});

export function useMarketplaceLabel() {
  const { datiTendineOrdine } = useLogisticaConfiguration();
  const labels = datiTendineOrdine?.marketplace?.labels;
  return useCallback((code, fallback = code) =>
    Object.prototype.hasOwnProperty.call(labels || {}, code) ? labels[code] : fallback,
  [labels]);
}

export function marketplaceChartRows(rows, label) {
  return (rows || []).map((row, index) => {
    const code = Object.prototype.hasOwnProperty.call(row, 'code') ? row.code : row.label;
    return { ...row, id: index, code, label: label(code, row.label) || 'N/D' };
  });
}

export function marketplaceExportFields(code, label) {
  return { Marketplace: label(code) || '', 'Codice marketplace': code || '' };
}
